
export class Inscricao{
    tipo : string;
    numero:number;
     constructor(){}
}